"use client";
import React, { useCallback, useEffect, useRef } from "react";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import { Box } from "@mui/material";
const CustomDataGridTable = ({
  columns,
  rows,
  onRowClick,
  pagination = { page: 0, rowsPerPage: 0, totalRows: 0 },
  onPageChange,
  onRowsPerPageChange,
  getRowClassName,
  hideFooter = false,
  loading,
  tableRef,
  sx = {},
  ...props
}) => {
  const { page, rowsPerPage, totalRows } = pagination;
  const handlePaginationChange = (model) => {
    const { page, pageSize } = model;
    onPageChange?.(page);
    onRowsPerPageChange?.(pageSize);
  };
  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box flex={1} overflow={"auto"} ref={tableRef}>
        <DataGrid
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page, pageSize: rowsPerPage },
            },
          }}
          pageSizeOptions={[5, 10, 25]}
          rowCount={totalRows}
          onPaginationModelChange={handlePaginationChange}
          disableRowSelectionOnClick
          hideFooter={hideFooter}
          onRowClick={(v,e)=> { e.stopPropagation();    if (window.getSelection().toString() === "") {onRowClick(v)}}}
          paginationMode="server"
          loading={loading}
          getRowClassName={getRowClassName}
          slotProps={{
            loadingOverlay: {
              variant: "skeleton",
              noRowsVariant: "skeleton",
            },
          }}
          sx={{
            "& .MuiDataGrid-row": {
              cursor: onRowClick ? "pointer" : "default",
            },
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
              boxShadow: "none",

            },
            "& .MuiDataGrid-columnHeader:focus": {
              outline: "none",
              boxShadow: "none",
            },
            "& .MuiDataGrid-cell button:focus": {
              outline: "none",
              boxShadow: "none",
            },
            "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
              outline: "none !important",
            },
            ...sx,
          }}
          {...props}
        />
      </Box>
    </Box>
  );
};
export default CustomDataGridTable;
